var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2363_6407"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon / Half-moon",
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icon / Half-moon",
    width: 16,
    height: 16,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2363_6407)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M6.18 1.99C6.18 1.76 6.06 1.55 5.86 1.43C5.67 1.31 5.42 1.29 5.22 1.4C4.05 1.98 3.07 2.87 2.38 3.98C1.69 5.09 1.33 6.36 1.33 7.67C1.33 9.24 1.86 10.78 2.84 12.01C3.82 13.25 5.19 14.12 6.73 14.48C8.26 14.84 9.88 14.67 11.31 14C12.73 13.33 13.89 12.19 14.59 10.77C14.7 10.57 14.68 10.32 14.56 10.13C14.44 9.93 14.23 9.81 14 9.81C11.26 9.81 9.34 9.13 8.1 7.89C6.86 6.65 6.18 4.73 6.18 1.99ZM3.51 4.68C3.88 4.09 4.34 3.58 4.89 3.17C5.06 5.55 5.79 7.47 7.16 8.83C8.52 10.2 10.44 10.93 12.83 11.1C12.28 11.82 11.56 12.4 10.74 12.79C9.58 13.34 8.28 13.47 7.03 13.18C5.79 12.89 4.68 12.19 3.89 11.19C3.09 10.18 2.66 8.94 2.66 7.67C2.66 6.61 2.96 5.58 3.51 4.68Z",
    fill: "#718EBF",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.85d2ea233c245bb840f29f0552fd2dc1.svg";
export { ForwardRef as ReactComponent };